import * as React from "react"
import { cn } from "../../lib/utils"

const Switch = React.forwardRef(({ 
  className, 
  checked, 
  onCheckedChange, 
  disabled,
  id,
  ...props 
}, ref) => {
  const handleClick = () => {
    if (!disabled && onCheckedChange) {
      onCheckedChange(!checked);
    }
  };

  const handleKeyDown = (e) => {
    if ((e.key === ' ' || e.key === 'Enter') && !disabled) {
      e.preventDefault();
      onCheckedChange(!checked);
    }
  };

  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      id={id}
      disabled={disabled}
      className={cn(
        // v9 .h-toggle: 42×24 track, 20×20 thumb with 2px inset.
        "peer relative inline-flex h-6 w-[42px] shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
        checked ? "bg-slate-900" : "bg-slate-200",
        className
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      {...props}
    >
      <span
        className={cn(
          "pointer-events-none absolute top-0.5 block h-5 w-5 rounded-full bg-white shadow-sm transition-all",
          checked ? "right-0.5" : "left-0.5"
        )}
      />
    </button>
  )
})
Switch.displayName = "Switch"

export { Switch }